/* ============================================================================
   EmbroideryFilter — an SVG filter that approximates an embroidered/stitched
   look for apparel logo/text previews: fuzzy thread edges (turbulence +
   displacement), a directional satin-stitch grain (dark, hue-preserving), and a
   faint thread sheen. Vistaprint bakes this server-side (Cimpress rendering);
   this is the client-side approximation. Render <EmbroideryDefs/> once at the
   app root, then apply `filter: EMBROIDERY_FILTER` to a design element.
   ============================================================================ */

export const EMBROIDERY_FILTER = 'url(#esy-embroidery)';

// Kept as a raw string so it renders exactly as tuned/verified.
const SVG = `
<svg width="0" height="0" aria-hidden="true" focusable="false" style="position:absolute;pointer-events:none">
  <defs>
    <filter id="esy-embroidery" x="-25%" y="-25%" width="150%" height="150%">
      <!-- fuzzy thread edges (small displacement keeps it clean) -->
      <feTurbulence type="fractalNoise" baseFrequency="0.9 0.9" numOctaves="2" seed="4" result="n"/>
      <feDisplacementMap in="SourceGraphic" in2="n" scale="2.2" xChannelSelector="R" yChannelSelector="G" result="rough"/>
      <!-- fine directional satin-stitch rows (dark, hue-preserving so colours stay vivid) -->
      <feTurbulence type="turbulence" baseFrequency="0.05 0.9" numOctaves="1" seed="2" result="st"/>
      <feColorMatrix in="st" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.18 0" result="stA"/>
      <feComposite in="stA" in2="rough" operator="in" result="stClip"/>
      <!-- subtle raised-thread sheen (Ink/Stitch-style specular) -->
      <feGaussianBlur in="rough" stdDeviation="0.7" result="b"/>
      <feSpecularLighting in="b" surfaceScale="2.2" specularConstant="0.45" specularExponent="8" lighting-color="#ffffff" result="sp">
        <feDistantLight azimuth="155" elevation="60"/>
      </feSpecularLighting>
      <feComposite in="sp" in2="rough" operator="in" result="spClip"/>
      <feComponentTransfer in="spClip" result="spSoft"><feFuncA type="linear" slope="0.18"/></feComponentTransfer>
      <feMerge><feMergeNode in="rough"/><feMergeNode in="stClip"/><feMergeNode in="spSoft"/></feMerge>
    </filter>
  </defs>
</svg>`;

export function EmbroideryDefs() {
  return <div aria-hidden style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: SVG }} />;
}
